import React, { useEffect } from "react";
import Navigation from "components/common/navigation";
import Space from "components/common/space";

import Footer from "components/common/footer";
import * as S from "./styled";
import { CamelotUpcoming } from "../camelot-upcoming";
import { CamelotLive } from "../camelot-live";
import { CamelotEnded } from "../camelot-ended";

enum ContestStatus {
  Upcoming = "Upcoming",
  Live = "Live",
  Ended = "Ended",
}

const actualStatus: ContestStatus = ContestStatus.Ended;

interface Props {
  contestId: number;
}

export function CamelotLayout({ contestId }: Props) {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "dark");
    return () => {
      document.documentElement.setAttribute("data-theme", "light");
    };
  }, []);

  const contentByStatus: Record<ContestStatus, React.ReactNode> = {
    [ContestStatus.Upcoming]: <CamelotUpcoming contestId={contestId} />,
    [ContestStatus.Live]: <CamelotLive contestId={contestId} />,
    [ContestStatus.Ended]: <CamelotEnded contestId={contestId} />,
  };

  return (
    <div>
      <Navigation isAppLink={actualStatus === ContestStatus.Ended} />
      <Space height={138} heightMobile={104} />
      <S.Wrapper>{contentByStatus[actualStatus]}</S.Wrapper>
      <Space height={172} heightMobile={92} />
      <Footer />
    </div>
  );
}
